// Third-party
import React from 'react';
import { withRouter, RouteComponentProps, Route, Redirect, Switch } from 'react-router';
import { formatMessage } from '../../../../utils/i18n';
import { PERMISSIONS, userHasPermission, userHasPermissionEnabled } from '../../../../utils/permissions';
import { FolderTabs } from '../../../components/navigation';

// Components
import EnterpriseMembers from './enterprise-members/EnterpriseMembers';
import EnterprisePortfolios from './EnterprisePortfolios';
import EnterpriseDetails from './EnterpriseDetails';

import User from '@/types/user';
import AppRegion from '@/types/app-region';
import EnterpriseInfos from '@/types/enterprise-infos';
import EnterpriseDetailInfo from '@/types/enterprise-detail-info';
import NavigationItem from '@/types/navigation-item';

type Props = RouteComponentProps & {
  user: User;
  enterprise: EnterpriseDetailInfo;
  appRegion: AppRegion;
  onSave: (info: EnterpriseInfos) => Promise<EnterpriseInfos>;
};

const AdminEnterprise = ({ user, enterprise, onSave, appRegion }: Props) => {
  if (!enterprise) {
    return null;
  }

  const memberAdmin = userHasPermissionEnabled(
    user,
    PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS,
    PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS_ADD,
    PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MEMBERS_REMOVE,
  );
  const modelAdmin = userHasPermission(user, PERMISSIONS.ENTERPRISE_ADMIN_GROUPS_MODELS);
  const redirect = memberAdmin ? '/admin/enterprise/members' : '/admin/enterprise/models';

  const getNavigationTabs = (): NavigationItem[] => [
    {
      label: formatMessage('Admin.Enterprise.EnterpriseMembers'),
      value: '/admin/enterprise/members',
      disabled: !memberAdmin,
    },
    {
      label: formatMessage('Admin.Enterprise.PortfoliosTitle'),
      value: '/admin/enterprise/models',
      disabled: !modelAdmin,
    },
  ];

  return (
    <div className="admin-enterprise enterprise-tab">
      <EnterpriseDetails enterprise={enterprise} onSave={onSave} user={user} />

      <FolderTabs items={getNavigationTabs()} />

      <div className="tab-content">
        <Switch>
          {memberAdmin && (
            <Route path="/admin/enterprise/members">
              <EnterpriseMembers />
            </Route>
          )}

          {modelAdmin && (
            <Route path="/admin/enterprise/models">
              <EnterprisePortfolios user={user} />
            </Route>
          )}

          <Redirect to={redirect} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(AdminEnterprise);
